<script>
		import { createEventDispatcher } from 'svelte';

const dispatch = createEventDispatcher();
export let accounts, selectedAccount;


</script>

<div class="modal panel">
<h2>Transfer</h2>
<!-- show all accounts that do not match the id of the selectedAccount-->
{#each accounts as account}
	{#if account.id != selectedAccount.id}
		<div class="transfer-account">
			<div class="transfer-account-name">
				{account.name}
			</div>
			<div class="transfer-account-balance">
				{account.bal}
			</div>
			<!-- input to type how much to transfer-->
			<div class="transfer-account-input">
				<input type="number" id="transfer-amount" name="transfer-amount" min="0" max={selectedAccount.bal} value={account.transfer_amt} on:change={dispatch('transfer-amount-change', {transfer_amt: account.transfer_amt})}>
			</div>
			<div class="transfer-account-actions">
				<button on:click={() => dispatch('transfer', {from: selectedAccount.id, to: account.id})}>Transfer</button>
			</div>
		</div>
	{/if}
{/each}
<!-- if account.msgs then display the error messages-->
{#if selectedAccount.msgs}
	<div class="transfer-msgs">
		{#each selectedAccount.msgs as msg}
			<div class="transfer-msg red">
				{msg}
			</div>
		{/each}
	</div>
{/if}

</div>

<style>
	
</style>